import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
})
export class DatePickerComponent implements OnInit, OnDestroy {
  @Input() public label: string;
  @Input() public startingValue?: Date;
  @Input() public minDate?: Date;
  @Input() public maxDate?: Date;
  @Output() public dateOnSelection = new EventEmitter<Date | undefined>();

  /**
   * This event is sent from outside the date picker.
   * It will be triggered when we have a new value for the date picker that wasn't triggered using the date picker itself.
   * This will be mostly used by the changes on the query params.
   * One important thing is from now on the state is not saved anymore when we move from page to page using the menu.
   * If we want the previous stage we could navigate back using the browser
   *
   *
   * One other important thing is that this will trigger when the query params update this component or when the user update this component.
   * That is the reason we make the equality check.
   */
  @Input() public newValueTriggered$?: Observable<Date | undefined>;

  public today: Date = new Date();
  public datesForm = new UntypedFormGroup({
    date: new UntypedFormControl(),
  });

  private _newValueSubscription$: Subscription;

  ngOnInit(): void {
    if (this.startingValue) {
      this.datesForm.get('date')?.setValue(this.startingValue);
    }

    this.datesForm.get('date')?.valueChanges.subscribe(() => {
      const date = this.datesForm.get('date')?.value;

      if (date) {
        this.dateOnSelection.emit(date);
      }
    });

    if (this.newValueTriggered$) {
      this._newValueSubscription$ = this.newValueTriggered$.subscribe((newDate: Date | undefined) => {
        if (newDate) {
          const formValue = this.datesForm.get('date')?.value;
          if (!formValue || newDate !== formValue) {
            this.datesForm.get('date')?.setValue(newDate);
          }
        } else {
          if (this.datesForm.get('date')?.value) {
            this.datesForm.reset();
          }
        }
      });
    }
  }

  ngOnDestroy(): void {
    this._newValueSubscription$?.unsubscribe();
  }

  public clearForm(): void {
    this.datesForm.reset();
    this.dateOnSelection.emit(undefined);
  }
}
